const _location = new URL(window.location);
const urlParams = new URLSearchParams(_location?.search);

const getParam = (name) => urlParams?.get(name);

export default { getParam };
